import type { WorkOrderPrintMode } from "../../../../../../../../../../../../../api/kehrblatt/letters"
import { normalizeWorkOrderLetterAddressForRequest } from "../../../../../../../../../../../../../api/kehrblatt/letters"
import type {
  LetterRecipientInput,
  LetterSelectionCommitPayload,
  LetterSelectionDraft,
  LetterSelectionRow,
} from "../contract"

const recipientInput = (
  mode: WorkOrderPrintMode,
  draft: LetterSelectionDraft,
): LetterRecipientInput => {
  if (mode !== "PERSONAL_LETTER") return { kind: "property_address" }

  if (draft.recipientCustomerId && draft.recipientContactPointId) {
    return {
      kind: "existing_contact",
      customer_id: draft.recipientCustomerId,
      contact_point_id: draft.recipientContactPointId,
      name: String(draft.recipientName ?? "").trim(),
    }
  }

  if (
    draft.recipientSource === "OBJECT_ADDRESS" &&
    draft.recipientCustomerId &&
    !draft.recipientContactPointId
  ) {
    const name = String(draft.recipientName ?? "").trim()

    return {
      kind: "customer_at_property_address",
      customer_id: draft.recipientCustomerId,
      ...(name ? { name } : {}),
    }
  }

  const address = normalizeWorkOrderLetterAddressForRequest(draft.recipientAddress)

  if (!address) throw new Error("Briefadresse fehlt.")

  return {
    kind: "manual_address",
    name: String(draft.recipientName ?? "").trim(),
    address,
  }
}

export const buildLetterSelectionPayload = (
  row: LetterSelectionRow,
  draft: LetterSelectionDraft,
): LetterSelectionCommitPayload => {
  const itemId = String(row.letterDeliveryBatchItemId ?? "").trim()

  if (!itemId) throw new Error("Terminbrief-Item fehlt.")

  if (draft.ignored) return { action: "ignore", letter_delivery_batch_item_id: itemId }

  return {
    letter_delivery_batch_item_id: itemId,
    print_mode: draft.mode,
    recipient: recipientInput(draft.mode, draft),
  }
}
